import { gql } from '@apollo/client';

export const getEstudiosEconomicos = gql`
  query estudiosEconomicosApi {
    getEstudios @rest(type: "estudiosEconomicosModel", path: "/gateway/webback/modules/reportes_economicos") {
      weekly
      ice
      ibp
      dt
    }
  }
`;
